import { Bell, LayoutGrid, ListTree, MessageSquareText, Users } from 'lucide-react'

export const settingsSections = [
  {
    path: '/einstellungen/feedback',
    title: 'Feedback',
    description: 'Feedback-Aktionen, Kategorien und Piktogramme einrichten.',
    Icon: MessageSquareText,
  },
  {
    path: '/einstellungen/module',
    title: 'Module',
    description: 'Module Rubriken zuordnen sowie Sichtbarkeit und Reihenfolge festlegen.',
    Icon: LayoutGrid,
  },
  {
    path: '/einstellungen/module-rechte',
    title: 'Module & Rechte',
    description: 'Zugriffsrechte, Personen und Rechtevorlagen verwalten.',
    Icon: Users,
  },
  {
    path: '/einstellungen/navigation',
    title: 'Navigation',
    description: 'Rubriken der Plattformnavigation gestalten und anordnen.',
    Icon: ListTree,
  },
  {
    path: '/einstellungen/benachrichtigungen',
    title: 'Benachrichtigungen',
    description: 'Mailversand, Startseiten-News und Modulverantwortliche verwalten.',
    Icon: Bell,
  },
].toSorted((left, right) => left.title.localeCompare(right.title, 'de'))
